import type { FooterProps } from '../../types';
import Typography from '../ui/Typography';

const Footer = ({ className = '' }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className={className}>
      <div className="divider mb-12"></div>
      <div className="flex flex-col lg:flex-row justify-between gap-10">
        <div className="max-w-xs shrink-0">
          <img
            src="/logo-light.png"
            alt="Theocraft"
            className="h-14 w-auto mb-4"
          />
          <Typography.Body>
            Leveraging AI & machine learning, data science, and software engineering to create meaningful solutions for companies.
          </Typography.Body>
        </div>
        <div className="max-w-xs shrink-0">
          <Typography.Title className="mb-4">Contact</Typography.Title>
          <a
            href="mailto:hello@theocraft.co"
            className="text-body block text-gray-400 hover:text-white mb-2 transition-colors"
          >
            hello@theocraft.co
          </a>
          <a
            href="tel:+2348101848410"
            className="text-body block text-gray-400 hover:text-white mb-4 transition-colors"
          >
            +234 810 184 8410
          </a>
          <Typography.Body>
            Suite 26, Rock of Ages Mall, Opposite Police Area Command, Oyemekun Road, Akure, Ondo State.
          </Typography.Body>
        </div>
        <div className="shrink-0">
          <Typography.Title className="mb-4">Connect</Typography.Title>
          <a
            href="https://www.linkedin.com/company/theocraft"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body block text-gray-400 hover:text-white mb-2 transition-colors"
          >
            LinkedIn
          </a>
          <a
            href="https://web.facebook.com/profile.php?id=61575058170284"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body block text-gray-400 hover:text-white mb-2 transition-colors"
          >
            Facebook
          </a>
          <a
            href="https://x.com/theocrafthq?s=21"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body block text-gray-400 hover:text-white transition-colors"
          >
            X (Twitter)
          </a>
        </div>
      </div>
      <Typography.Body className="mt-16 text-center text-gray-500">
        © {currentYear} Theocraft Digital Limited
      </Typography.Body>
    </footer>
  );
};

export default Footer; 